<template>
    <div v-cloak>
        <!-- Filters placement above items -->
        <div v-if="$store.state.filterPlacement === 'top'"
             :class="{ 'posts__filter-top--open' : $store.state.filtersShow }" class="posts__filter-top" id="filter">
            <filter-wrapper></filter-wrapper>
        </div>

        <!-- Filter state bar -->
        <filter-bar v-if="$store.state.filterPlacement === 'sidebar'"></filter-bar>

        <!-- Loader element -->
        <div :class="{ 'loader--loading' : $store.state.loading }" class="loader"></div>

        <!-- Client specific Nedap IDS -->
        <posts-nedap-ids v-if="postType === 'product' && $store.state.client === 'nedapids' && posts.items"
                         :ids_posts="posts.items"></posts-nedap-ids>

        <!-- Default post card view -->
        <div v-if="posts.items && clientSpecific()" class="row post-cards"
             :class="[classObject, { 'post-cards--loading' : $store.state.loading }, { 'post-cards--filtered' : $store.state.filterState }]">
            <post-card v-for="post in posts.items" v-bind:post="post"></post-card>
        </div>

        <!-- Pagination with some client specific conditionals -->
        <template v-if="clientSpecific(true)">
            <pagination v-model="posts.pagination.page" :records="posts.headers.totalItems" :per-page="posts.perPage"
                        @paginate="paginate()" :options="posts.pagination.options"/>
        </template>

    </div>

    <!-- Filters placement in sidebar -->
    <div v-if="$store.state.filterPlacement === 'sidebar'" :class="{ 'posts__filter--open' : $store.state.filtersShow }"
         class="posts__filter" id="filter">
        <filter-wrapper></filter-wrapper>
    </div>
</template>
<script>

import Filter from './Filter';
import FilterBar from './FilterBar';

import PostsNedapIDS from "./PostsNedapIDS.vue";

import PostCard from "./PostCard";
import PostCardEvent from "./PostCardEvent";
import PostCardCase from "./PostCardCase";
import DownloadCard from "./DownloadCard";
import Pagination from 'v-pagination-3';
import axios from "axios";
import MyPagination from './Pagination';
import {mapGetters} from "vuex";
import DynamicUrl from './DynamicUrl';
import FiltersFromAddressBar from "./FiltersFromAddressBar";
// import GetSeoText from "./GetSeoText";

export default {

    data() {
        return {
            posts: {
                headers: {
                    totalItems: 1,
                    totalPages: Number,
                },
                items: [],
                loader: 'loader.svg',
                perPage: this.$store.state.postPerPage,
                orderBy: this.$store.state.orderBy,
                excludedCategory: {},
                pagination: {
                    page: this.$store.state.page,
                    options: {
                        edgeNavigation: true,
                        theme: 'bootstrap4',
                        chunk: 10,
                        chunksNavigation: 'fixed',
                        template: MyPagination,
                        texts: {
                            nextChunk: '>>',
                            prevChunk: '<<'
                        }
                    }
                },
            },
            postType: '',
            postCategories: '',
            loadingState: false,
            filterVisible: false
        }
    },
    mixins: [DynamicUrl, FiltersFromAddressBar, PostsNedapIDS],
    computed: {
        ...mapGetters({
            filterTrigger: 'filterTrigger',
        }),

        classObject() {
            return {
                'post-cards--horizontal': this.postType === 'event',
                'post-cards--download': this.postType === 'download'
            }
        },
        resetFiltersAll() {
            return this.$store.state.resetAllFilters;
        },
        initialFilterLoad() {
            // When all filters are loaded from dom-element (at this state no filter checkbox is set yet)
            return this.$store.state.filtersInitialLoad;
        },
        allFiltersSetFromUrl() {
            return this.$store.state.allFiltersSetFromUrl;
        },
        watchFilterShowState() {
            return this.$store.state.filtersShow;
        }
    },
    watch: {
        filterTrigger() {
            // console.log('load from filterTrigger');
            this.resetPagination();
            this.$store.state.loading = true;
            this.getPosts();
            this.$store.state.resetAllFilters = false;
            this.createDynamicAddressbarUrl();
            // this.GetSeoText();
        },
        resetFiltersAll(value) {
            // Load all posts when we have resetted filters
            this.resetPagination();
            this.getPosts(value);
            this.$store.state.loading = true;
        },
        initialFilterLoad(value) {
            if (value === true) {
                // We can now set the filters from the URL sections because we have waited for all filterblocks to be loaded from the dom-element.
                this.setFiltersFromAddressbarUrl();
            }
        },
        allFiltersSetFromUrl() {
            // Load posts after we've setted filters from URL sections
            // Set page number from store
            this.posts.pagination.page = this.$store.state.page;
            this.$store.state.loading = true;
            this.$store.state.filterState = true;
            // console.log('getPosts + GetSeoText after filters set from page load');
            this.getPosts();
            // this.GetSeoText();
        },
        watchFilterShowState() {
            if (this.$store.state.filtersShow === true) {
                document.body.classList.add('wordpress-st-filter-open');
            } else if (this.$store.state.filtersShow === false) {
                document.body.classList.remove('wordpress-st-filter-open');
            }
        }
    },
    components: {
        Pagination,
        'post-card': PostCard,
        'post-card-event': PostCardEvent,
        'post-card-case': PostCardCase,
        'download-card': DownloadCard,
        'filter-wrapper': Filter,
        'filter-bar': FilterBar,
        'posts-nedap-ids': PostsNedapIDS
        // 'seo-text': GetSeoText
    },
    methods: {
        getPosts(isReset = false) {
            let _this = this;

            _this.postType = _this.$store.state.postType;


            // Fetch posts
            if (_this.loadingState === false) {
                _this.loadingState = true;
                let pagePosts = function pagePosts() {
                    let fetchUrl = _this.fetchUrl(isReset);

                    return axios.get(fetchUrl)
                        .then(response => {
                            // Set 'headers' meta data

                            _this.posts.headers.totalItems = parseInt(response.headers['x-wp-total']);
                            _this.posts.headers.totalPages = parseInt(response.headers['x-wp-totalpages']);

                            // Set total items
                            _this.fillTotalItems(_this.posts.headers.totalItems);

                            // Set posts to local data
                            _this.posts.items = response.data;

                            if (_this.$store.state.initialPageLoad === true) {
                                // _this.setCanonicals(_this.posts.pagination.page, _this.posts.headers.totalPages);
                            }

                            _this.$store.state.initialPageLoad = false;

                            // Done loading trigger
                            _this.$store.commit('doneLoadingCount');

                            console.info('%c getPosts() => ' + fetchUrl, 'color: #bada55');
                            // console.log('dubblecheck');
                            // _this.GetSeoText();
                        })
                        .catch(e => {
                            console.log(e);
                        });
                };

                let axiosQueue = [pagePosts()];
                if (axiosQueue) {
                    return Promise.all(axiosQueue)
                        .then(function (v) {
                            // Disable loading
                            _this.$store.state.loading = false;
                            _this.loadingState = false;
                        })
                        .catch((error) => {
                            console.error('getPosts() =>', error);
                        });
                }
            }
        },
        fillTotalItems(count) {
            document.getElementById('filter-bar-total').innerHTML = count;
        },
        paginate() {
            this.$store.state.loading = true;
            this.$store.state.page = this.posts.pagination.page;
            this.createDynamicAddressbarUrl();
            this.getPosts();
        },
        resetPagination() {
            this.$store.state.page = 1;
            this.posts.pagination.page = 1;
        },
        fetchUrl(isReset) {
            let perPage = this.posts.perPage;
            let postType = this.postType;
            let orderBy = this.posts.orderBy;

            let filterParamsString = '';
            let Filters = this.$store.state.Filters;

            let extFilters = this.$store.state.extFilters;

            // Add setted filters to URL
            Filters.forEach((filterItem, index) => {
                if (filterItem.values.length > 0) {
                    let paramName = filterItem.tax;
                    let paramValues = [];
                    filterItem.values.forEach((filterValue, index) => {
                        paramValues.push(filterValue.id);
                    });
                    let paramValuesString = paramValues.join(',');

                    filterParamsString += '&' + paramName + '=' + paramValuesString;
                }
            });

            // Add external setted filters to URL
            if (extFilters.values.length > 0) {
                let paramName = extFilters.tax;
                let paramValues = [];
                extFilters.values.forEach((filterValue, index) => {
                    paramValues.push(filterValue.id);
                });
                let paramValuesString = paramValues.join(',');

                filterParamsString += '&' + paramName + '=' + paramValuesString;
            }

            // Get pagenumber
            let pageNumber = this.$store.state.page.toString();

            // Basic URL parameters
            let fetchUrl = this.$store.state.baseUrl;
            fetchUrl += '/wp-json/wp/v2/';
            fetchUrl += postType;
            fetchUrl += '?per_page=' + perPage;
            if (orderBy !== 'date') {
                fetchUrl += '&orderby=' + orderBy;
            }
            fetchUrl += '&page=' + pageNumber;

            //
            //
            //
            // Nedap IDS specific
            if (this.$store.state.client === 'nedapids' && this.postType === 'product') {
                fetchUrl = this.$store.state.baseUrl;
                fetchUrl += '/wp-json/wp/v2/';
                fetchUrl += postType;
                fetchUrl += '?per_page=99';
                if (orderBy !== 'date') {
                    fetchUrl += '&orderby=' + orderBy;
                }
                console.log('fetchUrl Nedap IDS', fetchUrl);
            }

            // Nedap IDS specific
            if (this.$store.state.client === 'nedapids' && this.postType === 'event') {
                fetchUrl = this.$store.state.baseUrl;
                fetchUrl += '/wp-json/wp/v2/';
                fetchUrl += postType;
                fetchUrl += '?per_page=99';
                fetchUrl += '&orderby=event_date_start&order=asc';
                console.log('fetchUrl Nedap IDS', fetchUrl);
            }

            // Exclude category from to fetch data (setted by ACF on overviewpage)
            if (this.posts.excludedCategory) {
                let exclTaxObj = this.posts.excludedCategory;

                // Only add to URL when same category is not called by specific page load. (So it should be set as Filter already because then we do want to show this specific category)
                let addExcludeParam = true;
                Filters.forEach((filterItem, index) => {
                    if (filterItem.values.length > 0) {
                        let paramName = filterItem.tax;
                        if (paramName === exclTaxObj.taxonomy) {
                            addExcludeParam = false;
                        }
                    }
                });

                if (addExcludeParam === true) {
                    fetchUrl += '&' + exclTaxObj.taxonomy + '_exclude[]=' + exclTaxObj.term_id;
                }
            }

            // Add language parameter to ignore (admin) language setting from cookie
            if (this.$store.state.curLang) {
                fetchUrl += '&lang=' + this.$store.state.curLang;
            }

            if (!isReset) {
                fetchUrl += filterParamsString;
            }

            return fetchUrl;
        },
        getExcludedCategory() {
            // Get hidden filters (categories) from DOM so the categories can be excluded from fetching
            const excludedCategory = document.getElementById('posts').getAttribute('data-excluded-category');
            const excludedCategoryParsed = JSON.parse(excludedCategory);

            this.posts.excludedCategory = excludedCategoryParsed;
        },

        getCardHtml() {
            this.$store.state.cardHtml = document.getElementById('post-card-html').innerHTML;
        },

        clientSpecific(falsive = false) {
            if (this.$store.state.client === null) {
                return true;
            }

            if (this.$store.state.client === 'nedapids') {
                if (this.postType !== 'product') {
                    return falsive !== true;
                }
            }

        },

        // Get setted filters (only one taxonomy) from outside component based on 'data-filter-term' attr
        // Parent CSS ID must be 'filter-ext-filters'
        // Every filter item must have CSS class 'filter-ext-filter-items'
        getExternalSettedFilters() {
            let _this = this;
            let elSettedFilters = document.getElementById('filter-ext-filters');
            if (elSettedFilters) {
                let extTax = elSettedFilters.getAttribute('data-filter-term');
                let extTerms = document.getElementsByClassName('filter-ext-filter-items');
                let extFilterObject = {
                    tax: extTax,
                    tax_name: extTax,
                    values: []
                };

                this.$store.state.extFilters = extFilterObject;

                _this.externalSettedFiltersClickEvents(extTerms);
            }
        },

        externalSettedFiltersClickEvents(extTerms) {
            let _this = this;
            for (let term of extTerms) {
                term.addEventListener('click', function () {
                    let termId = term.getAttribute('data-filter-term-id');
                    let termName = term.getAttribute('data-filter-term-name');
                    let termSlug = term.getAttribute('data-filter-term-slug');
                    let filterItemObject = {
                        id: termId,
                        name: termName,
                        slug: termSlug
                    }

                    _this.setExternalFilter(filterItemObject);

                });
            }
        },

        setExternalFilter(filterItemObject) {
            let _this = this;
            let extFilters = this.$store.state.extFilters;
            let returnVal = false;
            if (Object.keys(extFilters.values).length > 0) {
                extFilters.values.forEach((settedItem, index) => {
                    if (settedItem.id === filterItemObject.id) {
                        _this.$store.state.extFilters.values.splice(index, 1);
                        returnVal = true;
                    }
                });
            }

            if (!returnVal) {
                this.$store.state.extFilters.values.push(filterItemObject);
            }

            // Remove all active classes
            let extTermEls = document.getElementsByClassName('filter-ext-filter-items');
            for (let term of extTermEls) {
                term.classList.remove('filter-ext-filter-items--active')
            }

            // Set active class
            extFilters.values.forEach((settedItem, index) => {
                let termEl = document.querySelector('[data-filter-term-id="' + settedItem.id + '"]');
                if (termEl) {
                    termEl.classList.add('filter-ext-filter-items--active');
                }
            });

            // Filterstate
            if (Object.keys(extFilters.values).length > 0) {
                _this.$store.state.filterState = true;
            }

            this.resetPagination();
            this.$store.state.loading = true;
            this.getPosts();
            this.$store.state.resetAllFilters = false;
            this.createDynamicAddressbarUrl();
        },


        // Initialize!
        init() {
            this.getExternalSettedFilters();
            this.getExcludedCategory();
            this.getCardHtml();

            let pathName = window.location.pathname;

            if (this.$store.state.curLang) {
                pathName = pathName.replace('/' + this.$store.state.curLang, '');
            }

            pathName = pathName.replace('/' + this.$store.state.pageSlug + '/', '');

            if (this.$store.state.subsiteSlug) {
                let subsiteSlug = this.$store.state.subsiteSlug.slice(0, -1);
                pathName = pathName.replace(subsiteSlug, '');
            }
            pathName = pathName.slice(0, -1); // remove trailing slash
            // console.log('pathName', pathName);
            // Only execute if URL does not contain any filters. If URL does contain filters getPosts() will be called after filters are set
            if (!pathName) {
                this.getPosts();
            }
        }
    },

    created() {
        // START
        this.init();
    }
}
</script>
